export const TAX_AUTHORITY_CONSENTS_CLICKED = 'TAX_AUTHORITY_CONSENTS_CLICKED';
export const TAX_AUTHORITY_CONSENTS_URL = 'TAX_AUTHORITY_CONSENTS_URL';
